/** Read bounded JSON without buffering an unbounded request or upstream response. */
export async function readBoundedJson(request: Request | Response, max = 64000): Promise<unknown> {
  if (Number(request.headers.get('Content-Length')) > max) {
    await request.body?.cancel()
    throw new Error('size')
  }
  const reader = request.body?.getReader()
  if (!reader) return null
  try {
    const chunks: Uint8Array[] = []
    let length = 0
    while (true) {
      const { value, done } = await reader.read()
      if (done) break
      length += value.byteLength
      if (length > max) {
        await reader.cancel()
        throw new Error('size')
      }
      chunks.push(value)
    }
    const buffer = new Uint8Array(length)
    let offset = 0
    for (const chunk of chunks) {
      buffer.set(chunk, offset)
      offset += chunk.byteLength
    }
    return JSON.parse(new TextDecoder().decode(buffer))
  } finally {
    reader.releaseLock()
  }
}
